import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'

import Header from '../components/Header/Header'

import Intro from '../sections/Intro'
import About from '../sections/About'
import Structure from '../sections/Structure'
import OccupationArea from '../sections/OccupationArea'
import Contact from '../sections/Contact'
import Footer from '../components/UI/Footer'

const App = props => (
  <main>
    <Helmet>
      <title>{props.site.siteMetadata.title}</title>
      <meta name='description' content={props.site.siteMetadata.seo.description} />
      <meta name='keywords' content={props.site.siteMetadata.seo.keywords} />
      <meta property='og:title' content={props.site.siteMetadata.title} />
      <meta property='og:description' content={props.site.siteMetadata.seo.description} />
      <meta
        property='og:image'
        content={props.site.siteMetadata.url + props.socialThumb.publicURL}
      />
      <meta property='og:url' content={props.site.siteMetadata.url} />
      <meta name='twitter:title' content={props.site.siteMetadata.title} />
      <meta name='twitter:description' content={props.site.siteMetadata.seo.description} />
      <meta
        name='twitter:image'
        content={props.site.siteMetadata.url + props.socialThumb.publicURL}
      />
      <meta name='twitter:card' content='summary_large_image' />
    </Helmet>
    <Header />
    <Intro />
    <About />
    <Structure />
    <OccupationArea />
    <Contact />
    <Footer />
  </main>
)

App.propTypes = {
  site: PropTypes.shape({
    siteMetadata: PropTypes.shape({
      title: PropTypes.string,
      seo: PropTypes.shape({
        description: PropTypes.string,
        keywords: PropTypes.string
      })
    }),
    socialThumb: PropTypes.shape({
      publicURL: PropTypes.string
    })
  })
}

const appQuery = graphql`
  query AppQuery {
    site {
      siteMetadata {
        title
        url
        seo {
          description
          keywords
        }
      }
    }
    socialThumb: file(relativePath: { eq: "social/social.jpg" }) {
      publicURL
    }
  }
`

export default () => <StaticQuery query={appQuery} render={data => <App {...data} />} />
